import Intercom, { update } from '@intercom/messenger-js-sdk';
import { isProdEnvironment } from '@/settings/environment.utils.js';

const isProd = isProdEnvironment();

export function registerIntercom (intercomJwt) {
    if (!isProd) return;

    Intercom({
        app_id: 'x2v03hee',
        hide_default_launcher: true,
        intercom_user_jwt: intercomJwt,
    });
}

export function updateIntercomTheme (isDarkMode = false) {
    if (!isProd) return;

    const newTheme = isDarkMode ? 'dark' : 'light';

    update({ theme_mode: newTheme });
}